export const LOAD_ALL_WORKERS = 'LOAD_ALL_WORKERS';
export const LOAD_ALL_ASSIGNMENTS_BY_PROJECT_ID = 'LOAD_ALL_ASSIGNMENTS_BY_PROJECT_ID';
export const UPDATE_ASSIGNMENTS_BY_PROJECT_ID_AND_SET_WORKERS_THERE = 'UPDATE_ASSIGNMENTS_BY_PROJECT_ID_AND_SET_WORKERS_THERE';

export function loadAllWorkers(data) {
  return {
    type: LOAD_ALL_WORKERS,
    payload: data,
  }
}

export function loadAllAssignmentsByProjectId(data) {
    return {
      type: LOAD_ALL_ASSIGNMENTS_BY_PROJECT_ID,
      payload: data,
    }
}

export function updateAssignmentsByProjectIdAndSetWorkersThere(data) {
    return {
      type: UPDATE_ASSIGNMENTS_BY_PROJECT_ID_AND_SET_WORKERS_THERE,
      payload: data,
    }
}


// WEBPACK FOOTER //
// ./src/actions/projectAssignment/index.js